module.exports = __webpack_public_path__ + "static/img/8.1da1350.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbaip/sku/T恤/8.png
// module id = aZuJ
// module chunks = 0